export default "__VITE_ASSET__DySZ1rJz__"